module.exports = __webpack_public_path__ + "img/change_ve.3dd3a5fc.png";